import PropTypes from 'prop-types';
import React from 'react';
import InputEditor from './InputEditor';
export default function (firstKey, secondKey) {
    const rangeInput = ({ value, onValue, props = {} }) => {
        const cellValue = value;
        const subElement = (editedKey) => {
            if (editedKey === this.state.editedKey) {
                const onKeyUp = ({ key, target: { value } }) => {
                    if (key === 'Enter') {
                        cellValue[editedKey] = parseFloat(value);
                        onValue(cellValue);
                    }
                };
                const onBlur = ({ target: { value } }) => {
                    cellValue[editedKey] = parseFloat(value);
                    onValue(cellValue);
                };
                const parseValue = v => (cellValue[editedKey] === parseFloat(cellValue[editedKey]) ? parseFloat(v) : v);
                return {
                    value: React.createElement(InputEditor, Object.assign({ initialValue: cellValue[editedKey], onKeyUp: onKeyUp, onBlur: onBlur, onValue: onBlur }, props)),
                };
            }
            return {
                value: value[editedKey],
            };
        };
        const leftElement = subElement(firstKey);
        const rightElement = subElement(secondKey);
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", Object.assign({}, leftElement.props), leftElement.value),
            React.createElement("div", Object.assign({}, rightElement.props), rightElement.value)));
    };
    rangeInput.propTypes = {
        value: PropTypes.any,
        onValue: PropTypes.func,
    };
    return rangeInput;
}
